(function () {
  /* Intercept fetch calls to /cart/add — works with Kaching Bundles + native ATC */
  var originalFetch = window.fetch;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    return originalFetch.apply(this, arguments).then(function (response) {
      /* Clone so we don't consume the body */
      if (url.includes('/cart/add')) {
        openCartDrawer();
      }
      return response;
    });
  };

  function openCartDrawer() {
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      trigger.click();
    }
  }
})();